export default {
  inboxLoading: false,
  sentLoading: false,
  closedLoading: false,
  inboxList: [],
  sentList: [],
  closedList: []
};
